import { z } from 'zod';

export const SCORE_OPERATORS = ['gte', 'lte', 'gt', 'lt', 'eq'] as const;

/** One comparison against a running score total. */
export const ScoreCondition = z.looseObject({
  scoreName: z.string(),
  characterId: z.string().optional(),
  operator: z.enum(SCORE_OPERATORS),
  value: z.number(),
});

/** One branch: all conditions ANDed; if they hold, route to targetNodeId. */
export const ScoreRouteBranch = z.looseObject({
  conditions: z.array(ScoreCondition),
  targetNodeId: z.string(),
});

/**
 * A score-driven exit route. Branches are evaluated in order, first match wins;
 * if none match, defaultNodeId is used. Structural shape only — semantic
 * integrity (target existence, declared scores, non-empty conditions/default)
 * is enforced by the shared `scoreRoutes` rule so those errors stay friendly.
 */
export const ScoreRoute = z.looseObject({
  branches: z.array(ScoreRouteBranch),
  defaultNodeId: z.string(),
});

/** An exit-route value is either a node-id string (legacy) or a ScoreRoute. */
export const ExitRouteValue = z.union([z.string(), ScoreRoute]);

export type ScoreCondition = z.infer<typeof ScoreCondition>;
export type ScoreRoute = z.infer<typeof ScoreRoute>;
